import logger from '@/utils/logger';
import {
  SET_SPINNER_LOADING,
  FETCH_API_VERSIONS
} from './constants';
import {
  makeCall
} from '../../../utils/request';
import {
  buildOptions,
  getEndPoints
} from '../../../utils/api-call';

export const state = {
  isLoading: false,
  stompSocket: null,
  wsConnected: false
};

export const actions = {
  [FETCH_API_VERSIONS] ({ commit }) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().app.apiVersion,
        buildOptions('GET'),
        commit
      )
        .then(response => {
          const version = response.data ? response.data : response;
          resolve(version);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  }
};

export const getters = {
  isLoading: state => state.isLoading
};

export const mutations = {
  [SET_SPINNER_LOADING] (currentState, toggle) {
    currentState.isLoading = toggle;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
